"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  flex-wrap: wrap;\n  flex-direction: row;\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    background-color: ", ";\n    border-radius: 3px;\n    border: 1px solid ", ";\n    color: ", ";\n    font-size: 16px;\n    font-weight: 300;\n    cursor: pointer;\n\n    ", "\n\n    div {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      ", "\n    }\n\n    &:hover {\n      border-color: ", ";\n      background-color: ", ";\n      box-shadow: 0 10px 25px 0 ", ";\n    }\n\n    ", "\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    border-color: ", ";\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 0px;\n  position: absolute;\n  opacity: 0;\n\n  span {\n    border-color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  &:checked + label {\n    border-color: ", ";\n    background-color: ", ";\n  }\n\n  &:checked + label > div > span:before {\n    content: '';\n    display: block;\n    background-color: ", ";\n    border-color: ", ";\n    height: 1rem;\n    width: 1rem;\n    border-radius: 50%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    height: auto;\n    width: ", ";\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  outline: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    align-items: center;\n    justify-content: center;\n    background-color: transparent;\n    height: 1.5rem;\n    width: 1.5rem;\n    border: 1px solid ", ";\n    border-radius: 50%;\n    margin-right: 0.5rem;\n    vertical-align: bottom;\n\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputStyleChecked = exports.inputStyle = exports.radioInputNoOutline = exports.radioInputLabelError = exports.inputGroupBlock = exports.inputGroup = exports.radioInputButton = exports.radioInputItem = exports.radioInputLabel = void 0;

var _stylitas = require("@creditas/stylitas");

var radioInputButton = function radioInputButton(_ref) {
  var theme = _ref.theme,
      checked = _ref.checked;
  var borderColor = checked ? theme.bColorsecondary05 : theme.bColorneutral03;
  return (0, _stylitas.css)(_templateObject(), borderColor, (0, _stylitas.mq)({
    display: ['flex', 'flex', 'flex', undefined, undefined, undefined]
  }));
};

exports.radioInputButton = radioInputButton;

var radioInputNoOutline = function radioInputNoOutline() {
  return (0, _stylitas.css)(_templateObject2());
};

exports.radioInputNoOutline = radioInputNoOutline;

var radioInputItem = function radioInputItem(_ref2) {
  var fullWidth = _ref2.fullWidth;
  var width = fullWidth ? '100%' : 'auto';
  return (0, _stylitas.css)(_templateObject3(), width);
};

exports.radioInputItem = radioInputItem;

var inputStyleChecked = function inputStyleChecked(_ref3) {
  var theme = _ref3.theme;
  return (0, _stylitas.css)(_templateObject4(), theme.bColorsecondary05, theme.bColorsecondary01, theme.bColorsecondary04, theme.bColorsecondary05);
};

exports.inputStyleChecked = inputStyleChecked;

var inputStyle = function inputStyle(_ref4) {
  var theme = _ref4.theme;
  return (0, _stylitas.css)(_templateObject5(), theme.bColorsecondary05);
};

exports.inputStyle = inputStyle;

var radioInputLabelError = function radioInputLabelError(_ref5) {
  var theme = _ref5.theme,
      error = _ref5.error;
  return error && (0, _stylitas.css)(_templateObject6(), theme.bColordanger);
};

exports.radioInputLabelError = radioInputLabelError;

var radioInputLabel = function radioInputLabel(_ref6) {
  var theme = _ref6.theme,
      fullWidth = _ref6.fullWidth;
  var labelWidth = fullWidth ? '100%' : 'auto';
  var labelStart = fullWidth ? 'flex-start' : 'center';
  var labelMargin = fullWidth ? '4px 0' : '0 4px 0 0';
  return (0, _stylitas.css)(_templateObject7(), theme.bColorneutral01, theme.bColorneutral03, theme.bColorneutral07, (0, _stylitas.mq)({
    margin: ['4px 0', '4px 0', '4px 0', labelMargin, labelMargin, labelMargin],
    width: ['100%', '100%', '100%', labelWidth, labelWidth, labelWidth]
  }), (0, _stylitas.mq)({
    justifyContent: ['flex-start', 'flex-start', 'flex-start', labelStart, labelStart, labelStart]
  }), theme.bColorsecondary05, theme.bColorneutral01, theme.bColorneutral03, (0, _stylitas.mq)({
    padding: ['0.95rem 1rem', '0.95rem 1rem', '0.95rem 1rem', '1rem', '1rem', '1rem'],
    textAlign: [undefined, undefined, undefined, 'center', 'center', 'center']
  }));
};

exports.radioInputLabel = radioInputLabel;

var inputGroup = function inputGroup() {
  return (0, _stylitas.css)(_templateObject8(), (0, _stylitas.mq)({
    justifyContent: [undefined, undefined, undefined, 'flex-start', 'flex-start', 'flex-start'],
    display: ['block', 'block', 'block', 'flex', 'flex', 'flex']
  }));
};

exports.inputGroup = inputGroup;

var inputGroupBlock = function inputGroupBlock() {
  return (0, _stylitas.css)(_templateObject9());
};

exports.inputGroupBlock = inputGroupBlock;